import React, { useEffect, useRef, useState } from "react";

// FadeIn: only fades when element is below the fold. Always-visible by default,
// so SSR/screenshot/no-JS users still see content.
export const FadeIn = ({ children, delay = 0, as: Tag = "div", ...rest }) => {
    const ref = useRef(null);
    const [state, setState] = useState("idle"); // idle | pending | visible

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        if (typeof IntersectionObserver === "undefined") {
            setState("visible");
            return;
        }

        const rect = el.getBoundingClientRect();
        const inView =
            rect.top <
                (window.innerHeight || document.documentElement.clientHeight) &&
            rect.bottom > 0;

        if (inView) {
            setState("visible");
            return;
        }

        setState("pending");
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setTimeout(() => setState("visible"), delay);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1, rootMargin: "0px 0px -40px 0px" },
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [delay]);

    const cls =
        state === "pending"
            ? "fade-in pending"
            : state === "visible"
              ? "fade-in visible"
              : "fade-in";

    return (
        <Tag ref={ref} className={cls} {...rest}>
            {children}
        </Tag>
    );
};

export default FadeIn;
